import React from 'react';
import PropTypes from 'prop-types';
import './ParallaxImage.css';

const ParallaxImage = ({ image }) => {
  return (
    <div className="parallax" style={{ backgroundImage: `url(${image})` }}>
      {/* Additional content can go here */}
    </div>
  );
};

ParallaxImage.propTypes = {
  image: PropTypes.string.isRequired,
};

export default ParallaxImage;
